module.exports = __webpack_public_path__ + "static/media/view-stay-updated-icon.f034a8e2.png";